"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsReferencedByFieldQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var SiteUrls_1 = require("@tableau/shared-urls/lib/src/SiteUrls");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var FieldsReferencedByFieldQueryGql_1 = require("../../queries/FieldsReferencedByFieldQueryGql");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
function selectConnectionListResult(resultData) {
    var field = resultData && resultData.fields && resultData.fields[0];
    switch (field.__typename) {
        case 'BinField':
        case 'CalculatedField':
        case 'CombinedField':
        case 'CombinedSetField':
        case 'GroupField':
        case 'HierarchyField':
        case 'SetField':
            return field && field.fieldsConnection;
        default:
            return null;
    }
}
function mapResultNode(node) {
    var datasource = node.datasource;
    var publishedDatasource = datasource && datasource.__typename === 'PublishedDatasource' ? datasource : null;
    var embeddedDatasource = datasource && datasource.__typename === 'EmbeddedDatasource' ? datasource : null;
    var workbook = embeddedDatasource ? embeddedDatasource.workbook : null;
    return {
        id: node.id,
        name: node.name,
        publishedDatasourceVizportalUrlId: publishedDatasource ? publishedDatasource.vizportalUrlId : null,
        embeddedDatasourceNodeId: embeddedDatasource ? embeddedDatasource.id : null,
        datasourceName: datasource ? datasource.name : null,
        workbookVizportalUrlId: workbook ? workbook.vizportalUrlId : null,
    };
}
function urlForLink(urls, rowData) {
    if (rowData.workbookVizportalUrlId && rowData.embeddedDatasourceNodeId) {
        return urls.workbookLineageFieldPath(rowData.workbookVizportalUrlId, rowData.id) +
            filterToEmbeddedDatasource(rowData.embeddedDatasourceNodeId);
    }
    else if (rowData.publishedDatasourceVizportalUrlId) {
        return urls.datasourceLineageFieldPath(rowData.publishedDatasourceVizportalUrlId, rowData.id);
    }
    return null;
}
function urlForAnchorLink(urls, rowData) {
    if (rowData.workbookVizportalUrlId && rowData.embeddedDatasourceNodeId) {
        return urls.workbookLineageFieldUrl(rowData.workbookVizportalUrlId, rowData.id) +
            filterToEmbeddedDatasource(rowData.embeddedDatasourceNodeId);
    }
    else if (rowData.publishedDatasourceVizportalUrlId) {
        return urls.datasourceLineageFieldUrl(rowData.publishedDatasourceVizportalUrlId, rowData.id);
    }
    return null;
}
function filterToEmbeddedDatasource(datasourceId) {
    return "?" + SiteUrls_1.CatalogUrlParamKeys.embeddedDataSource + "=" + datasourceId;
}
function nameForLink(rowData) {
    if (rowData.name === null || rowData.datasourceName === null) {
        return null;
    }
    return Localize_1.Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.datasourceName });
}
function FieldsReferencedByFieldQueryGrid(props) {
    var emptyGridMessage = Localize_1.Messages.EmptyFieldsReferencedByFieldGridMessage();
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: FieldsReferencedByFieldQueryGql_1.FieldsReferencedByFieldQueryGql, partialQueryVariables: { fieldId: props.fieldId }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(LinksDisplayGrid_1.LinksDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, link: props.useAnchor ? urlForAnchorLink : urlForLink, name: nameForLink, targetBlank: props.targetBlank, useAnchor: props.useAnchor });
    }));
}
exports.FieldsReferencedByFieldQueryGrid = FieldsReferencedByFieldQueryGrid;
//# sourceMappingURL=FieldsReferencedByFieldQueryGrid.js.map